module.exports = __webpack_public_path__ + "img/logo.c44a90ac.png";